// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e0-j";
export var fulfillmentFormRail = "_e0-i";
export var headerTitleRow = "_e0-l";
export var orderDetailsWrapper = "_e0-g";
export var orderLinkTrigger = "_e0-2";
export var paymentInformationGrid = "_e0-q";
export var paymentSummaryColumn = "_e0-r";
export var phoneShipmentPickerButton = "_e0-e";
export var phoneShipmentPickerButtonContent = "_e0-f";
export var phoneShipmentPickerButtonWrapper = "_e0-d";
export var phoneShipmentPickerTrigger = "_e0-c";
export var shipmentContainer = "_e0-k";
export var shipmentDetailsMainPane = "_e0-h";
export var shipmentNavigationCard = "_e0-a";
export var shipmentNavigationEdgeTrigger = "_e0-6";
export var shipmentNavigationRail = "_e0-3";
export var shipmentNavigationRailEnter = "_e0-5";
export var shipmentNavigationRailHeader = "_e0-9";
export var shipmentNavigationRailOverlay = "_e0-4";
export var shipmentNavigationScrim = "_e0-7";
export var shipmentSummaryFact = "_e0-n";
export var shipmentSummaryGrid = "_e0-m";
export var shipmentSummaryMetadataRow = "_e0-o";
export var shipmentSummaryTags = "_e0-p";
export var shipmentWorkspace = "_e0-0";
export var shipmentWorkspaceBodyTablet = "_e0-8";
export var shipmentWorkspaceContent = "_e0-b";
export var shipmentWorkspaceHeader = "_e0-1";